module.exports = __webpack_public_path__ + "img/ini.fbb1420b.svg";